import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const SidebarMenu = ({ items, openMenus, toggleMenu, onClose = null }) => {

  const location = useLocation();

  const isAnySubmenuActive = (submenu) => {
    if (!submenu) return false;
    return submenu.some(sub => {
      if (sub.path && location.pathname === sub.path) return true;
      if (sub.hasNestedSubmenu) return isAnySubmenuActive(sub.submenu);
      return false;
    });
  };

  const renderMenuItem = (item) => {
    const Icon = item.icon;
    const isActive = item.path && location.pathname === item.path;
    const isSubmenuActive = isAnySubmenuActive(item.submenu);
    const isOpen = item.stateKey ? openMenus[item.stateKey] : false;

    // Regular menu item without submenu
    if (!item.hasSubmenu && !item.hasNestedSubmenu) {
      return (
        <Link
          to={item.path}
          onClick={onClose}
          className={`flex items-center gap-3 px-4 py-2 rounded-md mb-1 transition-colors ${isActive
            ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 font-medium'
            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
        >
          <Icon size={20} />
          <span>{item.label}</span>
        </Link>
      );
    }

    // Menu item with submenu
    if (item.hasSubmenu) {
      const isAlwaysOpen = item.alwaysOpen;
      const showSubmenu = isAlwaysOpen || isOpen;

      return (
        <div className={`rounded-md mb-1 transition-colors ${isActive || isSubmenuActive
          ? 'bg-gray-50 dark:bg-primary-900/30'
          : 'hover:bg-gray-50 dark:hover:bg-gray-700'
          }`}>
          <div className={`flex items-center gap-2 px-4 py-2 ${isActive || isSubmenuActive
            ? 'text-gray-700 dark:text-primary-400 font-bold'
            : 'text-gray-700 dark:text-gray-300'
            }`}>
            <Link
              to={item.path}
              onClick={onClose}
              className="flex-1 flex items-center gap-3"
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
            {!isAlwaysOpen && (
              <button
                onClick={() => toggleMenu(item.stateKey)}
                className="p-1 hover:opacity-70 transition-opacity"
              >
                <ChevronDown
                  size={16}
                  className={`transform transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''
                    }`}
                />
              </button>
            )}
          </div>
          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${showSubmenu ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
            }`}>
            <div className="pb-2">
              {item.submenu.map((subItem, idx) => (
                <div key={subItem.path || idx}>
                  {renderNestedItem(subItem, 1)}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderNestedItem = (item, level) => {
    const Icon = item.icon;
    const isActive = item.path && location.pathname === item.path;
    const isSubmenuActive = isAnySubmenuActive(item.submenu);
    const isOpen = item.stateKey ? openMenus[item.stateKey] : false;
    const paddingLeft = level === 1 ? 'pl-8' : 'pl-12';

    // Nested submenu (like "Sıfır Portföyler")
    if (item.hasNestedSubmenu) {
      return (
        <div>
          <div
            className={`flex items-center gap-2 ${paddingLeft} pr-4 py-1.5 text-sm cursor-pointer transition-colors ${isSubmenuActive
              ? 'text-black font-bold dark:text-primary-300 '
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            onClick={() => toggleMenu(item.stateKey)}
          >
            <Icon size={16} />
            <span className="flex-1">{item.label}</span>
            <ChevronDown
              size={14}
              className={`transform transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''
                }`}
            />
          </div>
          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
            }`}>
            <div>
              {item.submenu.map((nestedItem) => (
                <div key={nestedItem.path}>
                  {renderNestedItem(nestedItem, level + 1)}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    // Regular submenu item
    return (
      <Link
        to={item.path}
        onClick={onClose}
        className={`flex items-center gap-3 ${paddingLeft}  pr-4 py-1.5 text-sm transition-colors ${isActive
          ? 'text-black dark:text-primary-300 font-medium'
          : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
          }`}
      >
        <Icon size={16} />
        <span>{item.label}</span>
      </Link>
    );
  };

  return (
    <>
      {items.map((item) => (
        <div key={item.path || item.label}>
          {renderMenuItem(item)}
        </div>
      ))}
    </>
  );
};

export default SidebarMenu;
